import * as web3 from '@solana/web3.js'
import { CSSProperties, useEffect, useState } from "react";
import { AdCampaign } from "../models/AdCampaign";
import { useProgram } from '../utils/ProgramContext';

const styles: { [key: string]: CSSProperties } = {
    list: {
        padding: 0,
        listStyleType: 'none',
    },
    listItem: {
        margin: '10px 0',
        padding: '15px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
    },
    name: {
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    checkbox: {
        marginRight: '10px',
    },
};


interface AdProps {
    publicKey: web3.PublicKey;
}


const AdContainer: React.FC<AdProps> = ({ publicKey }: AdProps) => {
    const [ad, setAd] = useState<AdCampaign | undefined>(undefined)
    const { program } = useProgram() || {}

    useEffect(() => {
        const getAccount = async () => {
            if (!program) {
                return
            }
            const ad = await program.account.adCampaign.fetch(publicKey)
            setAd(new AdCampaign(ad.id as number, ad.name as string, ad.link as string, publicKey))
        }
        getAccount()
    }, [publicKey])

    return (
        ad ?
            <div >
                <div style={styles.name}>Name: {ad.name}</div>
                <div style={styles.name}>PubKey: {ad.publicKey?.toString()}</div>
                <img src={ad.link} style={{ maxHeight: "150px" }} />
            </div> :
            <></>

    );
};

export default AdContainer;
